// extracted by mini-css-extract-plugin
module.exports = {"tagSelectorContainer":"TagSelector_tagSelectorContainer__1S6VB","tagBlock":"TagSelector_tagBlock__33avc"};